/* ==========================================================================
   Variant image swap (Zippy Dynamics)
   --------------------------------------------------------------------------
   Makes the MAIN media gallery switch to the selected color's image instantly,
   client-side, instead of waiting for the theme's variant network fetch (which
   is what made the gallery "take a while to scroll to the product image", and
   left it on the default image after a reload).

   It only calls the theme's own media-gallery.setActiveMedia(), so the later
   network fetch still reconciles everything normally.

   Data comes from snippets/variant-image-swap.liquid: a variantId -> media id
   map built from each variant's featured media.
   ========================================================================== */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    document
      .querySelectorAll('script[type="application/json"][data-variant-image-swap]')
      .forEach(init);
  });

  function init(dataEl) {
    var cfg;
    try {
      cfg = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }
    if (!cfg || !cfg.variantMedia) return;

    var productId = String(cfg.productId);
    var map = cfg.variantMedia;
    var scope =
      dataEl.closest('product-info') ||
      document.getElementById('MainProduct-' + productId) ||
      document;
    var waiting = false;

    function mainVariantSelects() {
      var list = document.querySelectorAll(
        'variant-selects[data-product-id="' + productId + '"]'
      );
      for (var i = 0; i < list.length; i++) {
        var ctx = list[i].getAttribute('data-context') || '';
        if (ctx.indexOf('sticky') !== 0) return list[i];
      }
      return list[0] || null;
    }

    function gallery() {
      return (scope.querySelector && scope.querySelector('media-gallery')) ||
        document.querySelector('media-gallery');
    }

    // The variant id carried by the selected color swatch (its featured media
    // is the color's image).
    function selectedColorVariantId() {
      var vs = mainVariantSelects();
      if (!vs) return null;
      var checked = vs.querySelectorAll('input[type="radio"]:checked');
      for (var i = 0; i < checked.length; i++) {
        var label = checked[i].nextElementSibling;
        var sw = label && label.querySelector ? label.querySelector('.swatch') : null;
        if (sw && sw.getAttribute('data-variant-id')) {
          return sw.getAttribute('data-variant-id');
        }
      }
      return null;
    }

    // The swiper inits lazily (deferUntilInteraction + Motion.inView), and on a
    // media-heavy page that can take 10-20s. setActiveMedia can't move a slide
    // until swiper.initSwiper exists. Treat a non-carousel gallery (grid / no
    // swiper) as always ready.
    function swiperReady(g) {
      if (!g) return false;
      if (!g.classList.contains('media-gallery--carousel')) return true;
      var sc = g.querySelector('swiper-component');
      if (!sc) return true;
      return !!sc.initSwiper;
    }

    // Guard a swiper-component so its initializeSwiper can't run twice (which
    // would leak a second Swiper instance), then force it to initialize now —
    // instead of waiting 10-20s for the theme's deferred trigger. Safe because
    // the theme's later deferred call sees initSwiper already set and no-ops.
    function guardAndInit(sc) {
      if (!sc || sc.initSwiper || typeof sc.initializeSwiper !== 'function') return;
      if (!sc.__vimGuarded) {
        sc.__vimGuarded = true;
        var orig = sc.initializeSwiper.bind(sc);
        sc.initializeSwiper = function () {
          if (sc.initSwiper) return; // already initialized -> no-op
          return orig();
        };
      }
      try { sc.initializeSwiper(); } catch (e) {}
    }

    function forceSwiperInit() {
      if (typeof window.Swiper !== 'function') return false; // vendor.js not ready yet
      var g = gallery();
      if (!g || !g.classList.contains('media-gallery--carousel')) return true;
      var scs = g.querySelectorAll('swiper-component');
      for (var i = 0; i < scs.length; i++) guardAndInit(scs[i]);
      return true;
    }

    function desiredMediaId() {
      var vid = selectedColorVariantId();
      return vid ? map[vid] || null : null;
    }

    // Apply the CURRENTLY selected color's media (recomputed at call time so
    // rapid early clicks aren't lost) once the gallery + swiper are ready.
    function applyNow(smooth) {
      var g = gallery();
      if (!g || typeof g.setActiveMedia !== 'function') return false;
      if (!swiperReady(g)) { forceSwiperInit(); return false; }
      var mediaId = desiredMediaId();
      if (mediaId == null) return false;
      g.setActiveMedia(String(mediaId), !!smooth);
      return true;
    }

    // Keep retrying until the swiper is ready, then apply the latest selection.
    function applyWhenReady(smooth) {
      if (applyNow(smooth)) return;
      if (waiting) return;
      waiting = true;
      var tries = 0;
      (function loop() {
        if (applyNow(false)) { waiting = false; return; }
        if (tries++ < 250) setTimeout(loop, 100);
        else waiting = false;
      })();
    }

    document.addEventListener('change', function (e) {
      var vs = e.target.closest ? e.target.closest('variant-selects') : null;
      if (!vs) return;
      if ((vs.getAttribute('data-product-id') || '') !== productId) return;
      if ((vs.getAttribute('data-context') || '').indexOf('sticky') === 0) return;
      applyWhenReady(true);
    });

    // On load, show the selected variant's image as soon as the swiper is up.
    applyWhenReady(false);
  }
})();
